import styled from 'styled-components';
import OfferIconSvg from '../assets/hotels/details/offer.svg';
import {defaultTheme} from '@stencil/build-theme';

const OfferIcon = styled(OfferIconSvg as JSX.Element)`
  width: ${props => props.width || '1.2rem'};
  height: ${props => props.height || '1.2rem'};
  fill: ${props => props.fill || defaultTheme.colors.goYellow.base};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default OfferIcon;
